import React, { useState } from "react";
import Select from "react-select";
import { useUser } from "../../user/hooks";
import Button, { BUTTON_STYLES } from "../../common/components/Button";
import TextInput from "../../common/components/TextInput";
import TextArea from "../../common/components/TextArea";
import { useToken } from "../../auth/hooks";
import { useTab } from "../../tabs/hooks";
import { BASE_URL } from "../../constants";
import { ESF } from "../constants";

const Section = ({ heading, text, setText }) => {
  return (
    <section>
      <h4>{heading}</h4>
      <TextArea
        style={{ boxSizing: "border-box", width: "100%" }}
        value={text}
        onChange={setText}
        rows={4}
      />
    </section>
  );
};

const CreateForm = ({ incidentId }) => {
  const [_, backToList] = useTab("/sitrep");
  const customSelectStyles = {
    container: (provided) => ({
      ...provided,
      minWidth: 250,
      marginLeft: 20, //isDesktop ? 20 : 0,
    }),
    option: (provided) => ({ ...provided, color: "#000" }),
  };
  const token = useToken();
  const user = useUser();

  const [subject, setSubject] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [limitations, setLimitations] = useState("");
  const [futureConcerns, setFutureConcerns] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [author, setAuthor] = useState(user.name);
  const [esf, setEsf] = useState(ESF[0]);

  const handleSubmit = async () => {
    const body = {
      author,
      subject,
      ESF: esf.label,
      currentStatus,
      limitations,
      futureConcerns,
      additionalInfo,
      incidentId,
    };

    const response = await fetch(`${BASE_URL}api/sitrep/posts`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    backToList();
  };
  return (
    <div
      style={{
        color: "#EBF1F5",
        width: "70%",
        background: "#141414",
        minWidth: 280,
        padding: 20,
        margin: "10px auto",
        borderRadius: 5,
        boxShadow: "0px 10px 33px 0px rgba(0,0,0,0.75)",
      }}
    >
      <h3>Create New Post</h3>
      <TextInput
        type="text"
        id="subject"
        label="Title"
        value={subject}
        onChange={setSubject}
      />
      <Section
        heading="Current Status"
        text={currentStatus}
        setText={setCurrentStatus}
      />
      <Section
        heading="Limitations / Obstacles"
        text={limitations}
        setText={setLimitations}
      />
      <Section
        heading="Future Concerns"
        text={futureConcerns}
        setText={setFutureConcerns}
      />
      <Section
        heading="Additional Info"
        text={additionalInfo}
        setText={setAdditionalInfo}
      />
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "baseline",
          justifyContent: "space-between",
        }}
      >
        <TextInput
          type="text"
          id="author"
          label="Author"
          value={author}
          onChange={setAuthor}
        />

        <Select
          options={ESF}
          value={esf}
          onChange={setEsf}
          styles={customSelectStyles}
          menuPlacement="top"
        />
        <Button
          onClick={handleSubmit}
          text="POST"
          style={BUTTON_STYLES.PRIMARY}
        />
      </div>
    </div>
  );
};

export default CreateForm;
